import type { ComparisonRow, SimpleCard } from '../types/content';

export const quickBenefits: SimpleCard[] = [
  { title: '5 TOMOS', copy: 'Sistema completo' },
  { title: '250+ PÁGINAS', copy: 'Contenido práctico' },
  { title: '5 BONOS', copy: 'Herramientas de ejecución' },
  { title: 'ACCESO INMEDIATO', copy: 'Empieza hoy' }
];

export const problemCards: SimpleCard[] = [
  { title: 'PIERDES TIEMPO', copy: 'Horas pensando ejercicios y preparando sesiones.' },
  { title: 'REPITES CLASES', copy: 'Sin una progresión clara es fácil volver siempre a los mismos ejercicios.' },
  { title: 'EXPLICAS DEMASIADO', copy: 'Una corrección concreta muchas veces funciona mejor que un discurso técnico.' },
  { title: 'NIVELES MEZCLADOS', copy: 'Organizar grupos heterogéneos puede convertir una clase en un caos.' },
  { title: 'FALTA PROGRESIÓN', copy: 'El alumno entrena, pero no siempre entiende hacia dónde está avanzando.' },
  { title: 'IMPROVISACIÓN', copy: 'Sabes enseñar pádel. Lo difícil es convertir todo lo que sabes en un sistema.' }
];

export const benefitCards: SimpleCard[] = [
  { title: 'PREPARA MÁS RÁPIDO', copy: 'Reduce el tiempo que dedicas a buscar ejercicios y organizar ideas.' },
  { title: 'CORRIGE CON CRITERIO', copy: 'Identifica errores y prioriza las correcciones importantes.' },
  { title: 'CREA PROGRESIÓN', copy: 'Conecta las sesiones para que el alumno perciba continuidad.' },
  { title: 'ORGANIZA MEJOR LOS GRUPOS', copy: 'Utiliza estructuras pensadas para mantener más alumnos activos.' },
  { title: 'TRANSMITE PROFESIONALIDAD', copy: 'Haz que cada sesión tenga objetivo, estructura y sentido.' },
  { title: 'CONSULTA EN CUALQUIER MOMENTO', copy: 'Accede al material desde móvil, tablet u ordenador.' }
];

export const tomoCommonFeatures: SimpleCard[] = [
  { title: 'FICHA TÉCNICA', copy: 'Qué necesitas entender antes de enseñarlo.' },
  { title: 'SEMÁFORO DE ERRORES', copy: 'Qué detectar y qué corregir primero.' },
  { title: 'ESCALERA DE PROGRESIÓN', copy: 'Cómo avanzar desde lo sencillo hacia lo complejo.' },
  { title: 'TIP DEL PRO', copy: 'Detalles prácticos para llevar el concepto a pista.' }
];

export const insideScreenshots: string[] = [
  'Ficha Técnica',
  'Semáforo de Errores',
  'Escalera de Progresión',
  'Tip del Pro',
  'Ejemplo de Ejercicio',
  'Diagrama de Pista',
  'Planificación de Sesión',
  'Metodología de Trabajo'
];

export const valueStackItems: string[] = [
  'Tomo I — Defensa y Control',
  'Tomo II — Ataque y Definición',
  'Tomo III — Táctica y Estrategia',
  'Tomo IV — Metodología y Planificación',
  'Tomo V — Mentalidad, Físico y Negocio',
  '25 Fichas de Pista',
  'Radar del Alumno',
  '50 Correcciones Rápidas',
  'Planificador 30 Días',
  'Vuelta a Pista'
];

export const forWhoYes: string[] = [
  'Das clases de pádel y pierdes demasiado tiempo preparándolas.',
  'Estás empezando como monitor y quieres una estructura de trabajo.',
  'Ya tienes experiencia pero quieres organizar mejor tu metodología.',
  'Trabajas con grupos de distintos niveles.',
  'Quieres conectar técnica, táctica y planificación.',
  'Buscas que tus alumnos perciban una progresión más clara.',
  'Quieres consultar rápidamente ejercicios, errores y progresiones.',
  'Diriges o quieres organizar una escuela de pádel con mayor criterio metodológico.'
];

export const forWhoNo: string[] = [
  'Buscas una certificación oficial.',
  'Esperas convertirte en entrenador simplemente leyendo un manual.',
  'Quieres una biblioteca de ejercicios sin metodología.',
  'No tienes intención de aplicar lo aprendido en pista.'
];

export const proofStats: SimpleCard[] = [
  { title: '250+', copy: 'Páginas' },
  { title: '5', copy: 'Tomos' },
  { title: '5', copy: 'Herramientas prácticas' },
  { title: '25', copy: 'Fichas de Pista' },
  { title: '50', copy: 'Correcciones' },
  { title: '50', copy: 'Esquemas en Kit de Ejecución' },
  { title: '12', copy: 'Meses de planificación en Kit de Ejecución' }
];

export const comparisonRows: ComparisonRow[] = [
  { feature: '5 Tomos', base: true, kit: true },
  { feature: '250+ páginas', base: true, kit: true },
  { feature: '5 Bonos', base: true, kit: true },
  { feature: 'Fichas de Pista', base: true, kit: true },
  { feature: 'Radar del Alumno', base: true, kit: true },
  { feature: '50 Correcciones', base: true, kit: true },
  { feature: 'Planificador 30 Días', base: true, kit: true },
  { feature: 'Vuelta a Pista', base: true, kit: true },
  { feature: 'Mapa de Pista', base: false, kit: true },
  { feature: '50 Esquemas Visuales', base: false, kit: true },
  { feature: 'Programador 12 Meses', base: false, kit: true }
];
